import type { QuoteOptions } from 'paintscout'
import type { UpdateableProduct } from '../../../area-substrates'
import getProductFields from './get-product-fields'
import type { ProductFields } from './get-product-fields'

/**
 * @description Crew description and materialValues to be displayed
 * @returns crewDescription and productFields
 */
export const getCrewDescription = ({
  product,
  prep,
  hours,
  itemName,
  clientLabel,
  showValues,
  options,
  substrate
}: {
  product?: UpdateableProduct
  options: QuoteOptions
  prep: number
  hours: number
  itemName: string
  clientLabel: string
  showValues?: boolean
  substrate?: boolean
}): { crewDescription: string; productFields: ProductFields } => {
  const descriptionComponents = []
  /* "secondLine" is the line that has the client label and/or the prep/hours */
  const secondLine = []
  const hoursComponents = []

  if (substrate) {
    // toRenderableCrewSubstrateArea filter
    if (clientLabel || (clientLabel == '' && clientLabel.trim().toLowerCase() !== itemName.trim().toLowerCase())) {
      secondLine.push(itemName)
    }
  } else {
    // toRenderableCrewAreaSubstrate filter
    if (clientLabel && clientLabel !== itemName) {
      secondLine.push(itemName)
    }
  }
  if (prep && showValues) {
    hoursComponents.push(`Prep: ${prep}`)
    hoursComponents.push(`Labor: ${hours}`)
  }

  const labourHours = hoursComponents.join(' + ')
  if (labourHours) {
    secondLine.push(labourHours)
  }

  if (secondLine.filter(Boolean).length) {
    descriptionComponents.push(secondLine.join(' - '))
  }

  // Generate product related fields and description string
  let productFields: ProductFields = null
  if (product) {
    const { productFields: generatedFields, descriptionString } = getProductFields({
      product,
      options
    })

    descriptionComponents.push(descriptionString)

    productFields = {
      ...generatedFields
    }
  }

  // Clean and join our description components
  // the if statement above is sometimes pushing an empty string into descriptionComponents, the following removes them
  const noEmptyDescriptionComponents = descriptionComponents.filter((elem) => elem.length > 0)
  const crewDescription: string = noEmptyDescriptionComponents.join('\n')

  return { crewDescription, productFields }
}
